// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@umijs/deps/compiled/css-loader/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable no-duplicate-selectors */\n/* stylelint-disable */\n/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */\n.container___1Rq3A > * {\n  background-color: #fff;\n  border-radius: 4px;\n  box-shadow: 0 6px 16px -8px rgba(0, 0, 0, 0.08), 0 9px 28px 0 rgba(0, 0, 0, 0.05), 0 12px 48px 16px rgba(0, 0, 0, 0.03);\n}\n@media screen and (max-width: 480px) {\n  .container___1Rq3A {\n    width: 100% !important;\n  }\n  .container___1Rq3A > * {\n    border-radius: 0 !important;\n  }\n}\n", ""]);
// Exports
exports.locals = {
	"container": "container___1Rq3A"
};
module.exports = exports;
